// Booking panel on the tour page: date/price calendar, passengers, summary and mobile dock.
export default {
  bookingUi: {
    perAdult: 'por adulto',
    secureNote: 'Paga la seña con Pix (código QR o copia y pega). Recibes el voucher apenas se confirma.',
    calendar: {
      prevMonth: 'Mes anterior',
      nextMonth: 'Mes siguiente',
      today: 'Hoy',
      selected: 'Seleccionado',
      unavailable: 'No disponible',
      lowest: 'Precio más bajo del mes',
      legend: 'Leyenda del calendario',
      noDate: 'Aún no elegiste una fecha',
      noDateHint: 'Toca un día para ver su precio.',
      pricePerAdult: '{{price}} por adulto',
    },
    passengers: {
      title: 'Pasajeros',
      adults: 'Adultos',
      children: 'Niños',
      babies: 'Bebés',
      adultsAge: '10 años o más',
      childrenAge: '5 a 9 años',
      babiesAge: '0 a 4 años',
      each: '{{price}} c/u',
    },
    summary: {
      title: 'Resumen de la reserva',
      adultsLine_one: '{{count}} adulto × {{price}}',
      adultsLine_other: '{{count}} adultos × {{price}}',
      childrenLine_one: '{{count}} niño × {{price}}',
      childrenLine_other: '{{count}} niños × {{price}}',
      babiesLine_one: '{{count}} bebé',
      babiesLine_other: '{{count}} bebés',
      depositNow: 'Seña ahora · Pix',
      fullNow: 'Pago total ahora · Pix',
    },
    errors: {
      closed: 'No hay salidas en esta fecha. Elige otro día en el calendario.',
    },
    dock: {
      label: 'Reserva rápida',
      from: 'Desde',
      chooseDate: 'Elegir fecha',
    },
  },
};
